import React, { useContext } from "react";

import DailyTimesheetMain from "./DailyTimesheetMain";
import { NoTimesheetRequiredWrapper } from "./DailyTimesheetPage.styles";
import PageWrapper from "app/components/PageWrapper";
import SessionContext from "app/contexts/SessionContext";
import Text from "shared/components/data-display/mui/Text";

function DailyTimesheetPage() {
    const session = useContext(SessionContext);

    return (
        <PageWrapper breadcrumbMarginBottom={4} displayFooter={false}>
            {session.timesheetRequired ? (
                <DailyTimesheetMain session={session} />
            ) : (
                <NoTimesheetRequiredWrapper>
                    <Text variant="largeBold">
                        You do not require to enter timesheets
                    </Text>
                    <Text variant="smallLight">
                        Reach out your manager if you have questions.
                    </Text>
                </NoTimesheetRequiredWrapper>
            )}
        </PageWrapper>
    );
}

export default DailyTimesheetPage;
